import { type Color, DownOutlineIcon } from '@carboncopyco/icons';
import classNames from 'classnames';
import { ColorHex } from '../../constants';

export type ExpandDownIconProps = {
  rotate?: boolean;
  className?: string;
  color?: Color;
  size?: number;
};

export const ExpandDownIcon = ({
  rotate,
  className,
  color = ColorHex.natural300,
  size = 24,
}: ExpandDownIconProps) => {
  return (
    <div
      className={classNames(className, {
        'rotate-180': rotate,
      })}
    >
      <DownOutlineIcon
        color={color}
        size={size}
      />
    </div>
  );
};
